import { render, staticRenderFns } from "./Namespace.vue?vue&type=template&id=082b4fd3&scoped=true&"
import script from "./Namespace.vue?vue&type=script&lang=js&"
export * from "./Namespace.vue?vue&type=script&lang=js&"
import style0 from "./Namespace.vue?vue&type=style&index=0&id=082b4fd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082b4fd3",
  null
  
)

export default component.exports